import $ from "jquery";
import swiperSlider from "../swiperSlider/swiperSlider";

const awardYear = {
  variables: {
    slider: ".awards-icon-slider",
    url: window.location.href,
  },
  methods: {
    showActiveYear: function (year) {
      const $panels = $(".awards-section .awards-year-panel");
      const $activePanel = year
        ? $panels.filter(`[data-year="${year}"]`)
        : $panels.first();
      $panels
        .not($activePanel)
        .removeClass("active-year")
        .css("display", "none");
      $activePanel.addClass("active-year").css("display", "flex");
      awardYear.methods.toggleScrollbar($activePanel);
    },
    toggleScrollbar: function ($activePanel) {
      const cardCount = $activePanel.find(
        ".awards-container__cards--section"
      ).length;
      $(".awards-section .awards-container").toggleClass(
        "awards-container--scrollable",
        cardCount > 4
      );
    },
    yearSelectChangeHandler: function () {
      $("#awardYearSelect").on("change", function () {
        const selectedYear = $(this).val();
        awardYear.methods.showActiveYear(selectedYear);
        var obj = awardYear.methods.dataLayerObj({
          currentTarget: { innerText: selectedYear },
        });
        createDataLayer("buttonClick", obj);
      });
    },
    sliderView: function () {
      let swiperConfig = {
        loop: false,
        speed: 1000,
        slidesPerView: 1.2,
        spaceBetween: 20,
        breakpoints: {
          599: {
            slidesPerView: 2.2,
          },
        },
      };
      $(awardYear.variables.slider).length > 0 &&
        swiperSlider.methods.initializerSwiper(
          awardYear.variables.slider,
          swiperConfig
        );
    },
    awardButtonClickHandler: function () {
        $(".award-panel .primary-button").on('click', (e)=>{
          var obj = awardYear.methods.dataLayerObj(e);
          createDataLayer('buttonClick', obj);
        });
    },
            dataLayerObj: function (e) {
                var obj = {
                    'articleName': "",
                    'blogCategory': "",
                    'blogPageCategory': "",
                    'buttonText': e.currentTarget.innerText.replace(/\n/g, '').trim(),
                    'pageSection': "Award Years",
                    'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? awardYear.variables.url.includes("blog") ? "Blogs" : awardYear.variables.url.substring(awardYear.variables.url.indexOf(".com/"), awardYear.variables.url.lastIndexOf('/')  === ".com") && !awardYear.variables.url.substring(awardYear.variables.url.indexOf(".com/"), awardYear.variables.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                    'planOption': "",
                    'productCategory': "",
                    'productName': "",
                    'question': "",
                    'source': "",
                    'searchTerm': "",
                    'videoTitle': "",
                    'bannerName': "",
                };
                return obj;
            },
    init: function () {
      this.yearSelectChangeHandler();
      this.showActiveYear($("#awardYearSelect").val());
    },
  },
};

$(document).ready(function () {
awardYear.methods.awardButtonClickHandler();
});
$(() => {
  if ($(".awardyear").length > 0) {
    awardYear.methods.init();
  }
  if ($(window).width() < 1199 && $(".award-panel").length > 0) {
    awardYear.methods.sliderView();
  }
});
